module.exports = __webpack_public_path__ + "img/banner2.ad26d442.png";